<template>
  <div :class="$b()">
    <VisionTag
      v-if="!loading && stockThresholdText"
      :text="stockThresholdText"
      :theme="stockThresholdTheme"
      size="small"
    />
    <div
      v-else-if="loading"
      class="vision-shimmer"
      :class="$b('shimmer')"
      :style="{ width: '95px', height: '18px' }"
    />
  </div>
</template>
<script>
import CustomisedProduct from '~/models/CustomisedProduct'

export default defineNuxtComponent({
  name: 'StockThresholdIndicator',

  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  created() {
    if (this.showStockCount) {
      this.loading = true
    }
  },

  beforeUnmount() {
    clearInterval(this.stockLoadingInterval)
  },

  async beforeMount() {
    if (this.showStockCount) {
      await this.update()
      this.stockLoadingInterval = setInterval(this.update, 5000)
    } else {
      this.loading = false
    }
  },

  computed: {
    showStockCount() {
      return this.customisedProduct
        .product.pdpConfigWithDefaults.stockIndicatorThresholdText.includes(
          'stockCount'
        )
    },

    remainingStock() {
      if (this.customisedProduct.product.quantity === 0) {
        clearInterval(this.stockLoadingInterval)
      }

      return this.customisedProduct.product.quantity
    },

    stockThresholdText() {
      const thresholdText =
        this.customisedProduct.product.pdpConfigWithDefaults
          .stockIndicatorThresholdText || 'stockCount remaining'

      if (this.showStockCount && this.remainingStock !== 0) {
        return thresholdText.replace('stockCount', this.remainingStock)
      } else if (this.showStockCount) {
        return (
          this.customisedProduct.product.pdpConfigWithDefaults
            .stockIndicatorSoldOutText ?
              this.customisedProduct
                .product.pdpConfigWithDefaults.stockIndicatorSoldOutText : 'Sold out'
        )
      }

      return this.customisedProduct.product.pdpConfigWithDefaults
        .stockIndicatorThresholdText
        ? this.customisedProduct.product.pdpConfigWithDefaults
            .stockIndicatorThresholdText
        : 'Limited stock'
    },

    stockThresholdTheme() {
      return this.customisedProduct.product.tagTheme || 'orange'
    }
  },

  methods: {
    async update () {
      try {
        const commerceIds = this.customisedProduct.commerceIds
        
        const freshStockResponse = await $fetch('/api/' + useRoute().params.locale + '/stock', {
          method: 'POST',
          body: {
            commerceIds: commerceIds.map(id => `id:${id}`).join(' OR '),
          }
        })

        this.customisedProduct.updateProductFromShopifyResponse(
          this.customisedProduct,
          freshStockResponse
        )

        this.loading = false
      } catch (error) {
        this.$sentry.captureException(error)
      }
    }
  }
})
</script>
<style lang="postcss">
.StockThresholdIndicator {
  @apply inline-block;
}

.StockThresholdIndicator__shimmer {
  @apply rounded-sm;
}
</style>
